import { translate } from "../../util/translate"

export const chargeTableHeaders = [
  {
    text: translate['charge.label.code'],
    value: 'code',
    width: 80,
  },
  {
    text: translate['charge.label.payer'],
    value: 'payer.real_estate.name',
    width: 350,
  },
  {
    text: translate['charge.label.type'],
    value: 'type',
    width: 150,
  },
  {
    text: translate['charge.label.status'],
    value: 'status',
    align: 'center',
    width: 80,
  },
  {
    text: translate['charge.label.amount'],
    value: 'value',
    align: 'right',
    width: 150,
  },
  {
    text: translate['charge.label.appointment'],
    value: 'appointment',
    align: 'center',
    width: 150,
  },
  {
    text: translate['charge.label.payments'],
    value: 'actions',
    align: 'center',
    width: 80,
  },
]

export const adminChargeTableHeaders = [
  {
    text: translate['charge.label.code'],
    value: 'code',
    width: 100,
  },
  {
    text: translate['charge.label.payer'],
    value: 'payer',
  },
  {
    text: translate['charge.label.type'],
    value: 'type',
    width: 250,
  },
  {
    text: translate['charge.label.status'],
    value: 'status',
    width: 100,
  },
  {
    text: translate['charge.label.appointment'],
    value: 'appointment',
    width: 200,
  },
  {
    text: translate['charge.label.amount'],
    value: 'value',
    align: 'end',
    width: 200,
  }
]
